import { Grid, Box, ThemeUIStyleObject } from 'theme-ui';
import ImageZoom from '~/components/Generic/ImageZoom';
import { CombinedMedia } from '~/utils/combine-media';

type Props = {
  images: CombinedMedia['mediaArrayWithThumbnails'];
  zoomedImages?: CombinedMedia['mediaArrayWithVideos'];
  cardWidthRef?: React.MutableRefObject<string | undefined>;
  fromPdp?: boolean;
  forwardSx?: ThemeUIStyleObject;
  badge?: Queries.BadgeFragment | null;
};
const ProductImages = ({ images, zoomedImages = [], cardWidthRef, fromPdp, forwardSx, badge }: Props) => {
  // read width from product showcase cards
  return (
    <Grid
      width={cardWidthRef?.current ? cardWidthRef?.current : '100%'}
      sx={{
        gap: ['2rem'],
        gridTemplateColumns: ['1fr', null, `repeat(2, 1fr)`],
        ...forwardSx,
      }}
    >
      {images.map((image, index) => {
        return (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              '.gatsby-plugin-image-wrapper > div': { pb: '100% !important' },
            }}
            key={`pdp-image-${index}`}
          >
            <ImageZoom
              image={image}
              zoomedImages={zoomedImages}
              index={index}
              fromPdp={fromPdp}
              forwardSx={{ width: '100%', img: { objectFit: 'cover' } }}
              badge={index === 0 ? badge : undefined}
            />
          </Box>
        );
      })}
    </Grid>
  );
};

export default ProductImages;
